
import PricingLayout from 'layouts/auth/variants/Pricing_copy';

import dashlight from 'assets/img/jorno/light.png';
import dashdark from 'assets/img/jorno/dark.png';
import { useColorModeValue } from "@chakra-ui/system";
import { Flex, Text } from "@chakra-ui/react";

export default function Landing() {

    const image = useColorModeValue(dashlight, dashdark);

    return (
    <PricingLayout contentTop={{ base: '60px', md: '8vh' }} contentBottom={{ base: '50px', lg: 'auto' }}>
      <Flex direction="column" alignSelf="center" justifySelf="center" overflow="hidden">
        <Flex direction="column" textAlign="center" justifyContent="center" align="center" mb="38px">
          <Text zIndex="1" fontSize="35px" color="white" fontWeight="700" lineHeight="52px">
            This site is no longer available
          </Text>
          <Text zIndex="1" fontSize="md" color="white" fontWeight="bold" mt="10px" mb="26px" maxW="400px">
            Good luck with your trading journey
          </Text>
        </Flex>
      </Flex>
    </PricingLayout>
  );
}